/**
 * CloudSaveButton Component
 *
 * Button that opens the SaveSlotsDialog for server-side save management.
 */

import { useState } from 'react';
import { Cloud } from 'lucide-react';
import { SaveSlotsDialog } from './SaveSlotsDialog';

export function CloudSaveButton() {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setDialogOpen(true)}
        className="flex items-center gap-1.5 rounded-md bg-blue-600 px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-blue-500"
        title="Cloud Save Slots"
      >
        <Cloud className="h-4 w-4" />
        <span>Cloud</span>
      </button>

      <SaveSlotsDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  );
}
